import { cx } from '@/lib/cx';

import { avaliarForcaSenha, type NivelForcaSenha } from './forca-senha';

/** Cor do trecho aceso por nível (indicador gráfico: basta 3:1 contra o trilho). */
const TOM: Record<NivelForcaSenha, string> = {
  0: 'bg-superficie-afundada',
  1: 'bg-perigo',
  2: 'bg-alerta',
  3: 'bg-info',
  4: 'bg-sucesso',
};
const SEGMENTOS = [1, 2, 3, 4] as const;

/**
 * Medidor de força da senha em 4 trechos, com o nível por extenso ("Força: Boa") e a dica do
 * próximo passo — cor nunca é a única pista. O texto é região `polite`: o leitor de tela anuncia
 * quando o nível muda, não a cada tecla. Vai logo abaixo do campo onde a senha é DEFINIDA.
 */
export function MedidorForcaSenha({ senha, className }: { senha: string; className?: string }) {
  const { nivel, rotulo, dica } = avaliarForcaSenha(senha);
  return (
    <div className={cx('grid gap-1', className)}>
      <div
        role="meter"
        aria-label="Força da senha"
        aria-valuemin={0}
        aria-valuemax={4}
        aria-valuenow={nivel}
        aria-valuetext={rotulo || 'Senha vazia'}
        className="grid grid-cols-4 gap-1"
      >
        {SEGMENTOS.map((segmento) => (
          <span
            key={segmento}
            className={cx(
              'h-1 rounded-pilula transition-colors duration-[var(--duracao-media)] ease-saida',
              segmento <= nivel ? TOM[nivel] : 'bg-superficie-afundada',
            )}
          />
        ))}
      </div>
      <p aria-live="polite" className="min-h-4 text-xs text-texto-suave">
        {rotulo && (
          <>
            Força: <span className="font-medium text-texto">{rotulo}</span>
            {dica && <> · {dica}</>}
          </>
        )}
      </p>
    </div>
  );
}
